var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"p-0 pr-2",attrs:{"color":"primary"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('vx-tooltip',{attrs:{"text":_vm.toolTipText}},[_c('vs-button',{staticClass:"w-auto h-auto p-1",attrs:{"type":"flat","color":"light","icon-pack":"feather","icon":"icon-copy"},on:{"click":_vm.copy}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }